import { useEffect } from "react"
import { toast } from "sonner"

interface UrlToastParams {
  toast_success?: string
  toast_error?: string
  toast_info?: string
  toast_warning?: string
}

export const useUrlToast = () => {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const params: UrlToastParams = {
      toast_success: urlParams.get("toast_success") || undefined,
      toast_error: urlParams.get("toast_error") || undefined,
      toast_info: urlParams.get("toast_info") || undefined,
      toast_warning: urlParams.get("toast_warning") || undefined
    }

    // Show toasts based on URL parameters
    if (params.toast_success) {
      toast.success(params.toast_success)
    }
    if (params.toast_error) {
      toast.error(params.toast_error)
    }
    if (params.toast_info) {
      toast.info(params.toast_info)
    }
    if (params.toast_warning) {
      toast.warning(params.toast_warning)
    }

    // Clean up URL parameters after showing toasts
    const hasToastParams = Object.values(params).some((value) => value !== undefined)
    if (hasToastParams) {
      const newUrl = new URL(window.location.href)
      Object.keys(params).forEach((key) => {
        newUrl.searchParams.delete(key)
      })
      window.history.replaceState({}, "", newUrl.toString())
    }
  }, [])
}
